import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "datesContainer"]
  
  connect() {
    this.updateAllContainers()
  }
  
  toggleSanction(event) {
    const checkbox = event.target
    const sanctionId = checkbox.dataset.sanctionId
    const isChecked = checkbox.checked
    
    
    this.updateContainersForSanction(sanctionId, isChecked)
  }
  
  updateContainersForSanction(sanctionId, isVisible) {
    // Show or hide the dates of that sanction.
    this.datesContainerTargets.forEach(container => {
      if (container.dataset.sanctionId === sanctionId) {
        if (isVisible) {
          container.classList.remove('hidden')
        } else {
          container.classList.add('hidden')
          // Unticked, the sanction loses its dates.
          this.clearDateFields(container)
        }
      }
    })
  }
  
  updateAllContainers() {
    this.checkboxTargets.forEach(checkbox => {
      const sanctionId = checkbox.dataset.sanctionId
      const isChecked = checkbox.checked
      this.updateContainersForSanction(sanctionId, isChecked)
    })
  }
  
  clearDateFields(container) {
    // Flatpickr text fields, not native date inputs.
    container.querySelectorAll('input').forEach(input => {
      if (input._flatpickr) input._flatpickr.clear()
      else input.value = ''
    })
  }
} 